import { useState } from 'react';

export function AircraftSlider() {
  const [activeIndex, setActiveIndex] = useState(1);

  const aircraft = [
    {
      name: 'DJT City',
      subtitle: 'Championing urban air travel',
      description: 'Designed for short-distance urban flights, the DJT City offers efficient, quiet transportation within city limits.',
      specs: {
        passengers: '2',
        range: '35 km',
        speed: '110 km/h',
        altitude: '500 m'
      },
      image: 'https://readdy.ai/api/search-image?query=sleek%20modern%20electric%20vertical%20takeoff%20landing%20aircraft%20eVTOL%20white%20and%20teal%20color%20scheme%20hovering%20above%20futuristic%20city%20landing%20pad%20clean%20minimalist%20background%20professional%20product%20photography&width=1200&height=800&seq=city1&orientation=landscape'
    },
    {
      name: 'DJT Region',
      subtitle: 'Connecting cities with suburbs',
      description: 'Built for longer journeys, the DJT Region connects urban centers with surrounding areas, offering extended range and capacity.',
      specs: {
        passengers: '1+5',
        range: '250 km',
        speed: '150 km/h',
        altitude: '1000 m'
      },
      image: 'https://readdy.ai/api/search-image?query=larger%20electric%20vertical%20takeoff%20landing%20aircraft%20eVTOL%20four%20passenger%20capacity%20white%20and%20teal%20design%20flying%20over%20suburban%20landscape%20clean%20sky%20background%20professional%20product%20photography&width=1200&height=800&seq=region1&orientation=landscape'
    }
  ];

  return (
    <section id="aircraft" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-16">
          <p className="text-sm font-semibold text-gray-500 mb-2 tracking-wider">
            OUR AIRCRAFT SOLUTIONS
          </p>
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-6">
            Flying made quiet and emission-free
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl">
            We pioneer Urban Air Mobility with our electric vertical takeoff and landing (eVTOL) aircraft: the DJT City and DJT Region for passengers – all powered by our innovative technology.
          </p>
        </div>

        <div className="relative">
          <div className="overflow-hidden rounded-2xl bg-white shadow-xl">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              <div className="aspect-[4/3] lg:aspect-auto">
                <img
                  src={aircraft[activeIndex].image}
                  alt={aircraft[activeIndex].name}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="p-12 flex flex-col justify-center">
                <h3 className="text-5xl font-light text-gray-900 mb-2">
                  <span className="font-serif italic">DJT</span>
                  <span>{aircraft[activeIndex].name.replace('DJT ', '')}</span>
                </h3>
                <p className="text-xl text-gray-600 mb-8">
                  {aircraft[activeIndex].subtitle}
                </p>

                <div className="grid grid-cols-2 gap-6 mb-8">
                  <div>
                    <p className="text-sm text-gray-500 mb-1">Passengers</p>
                    <p className="text-2xl font-semibold text-gray-900">{aircraft[activeIndex].specs.passengers}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1">Range</p>
                    <p className="text-2xl font-semibold text-gray-900">{aircraft[activeIndex].specs.range}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1">Max Speed</p>
                    <p className="text-2xl font-semibold text-gray-900">{aircraft[activeIndex].specs.speed}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1">Altitude</p>
                    <p className="text-2xl font-semibold text-gray-900">{aircraft[activeIndex].specs.altitude}</p>
                  </div>
                </div>

                <p className="text-gray-600 mb-8">
                  {aircraft[activeIndex].description}
                </p>

                <button className="inline-flex items-center px-8 py-3 bg-gray-900 text-white rounded-full hover:bg-gray-800 transition-colors group whitespace-nowrap w-fit cursor-pointer">
                  <span>Learn More</span>
                  <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center mt-8 space-x-4">
            <button
              onClick={() => setActiveIndex(0)}
              className={`px-6 py-2 rounded-full transition-all cursor-pointer ${activeIndex === 0 ? 'bg-gray-900 text-white' : 'bg-white text-gray-900 hover:bg-gray-100'}`}
            >
              DJT City
            </button>
            <button
              onClick={() => setActiveIndex(1)}
              className={`px-6 py-2 rounded-full transition-all cursor-pointer ${activeIndex === 1 ? 'bg-gray-900 text-white' : 'bg-white text-gray-900 hover:bg-gray-100'}`}
            >
              DJT Region
            </button>
          </div>

          <div className="flex items-center justify-center mt-4">
            <div className="flex items-center space-x-2 text-sm text-gray-600">
              <span className="font-semibold">{activeIndex + 1}</span>
              <div className="w-16 h-0.5 bg-gray-300">
                <div className={`h-full bg-gray-900 transition-all duration-300 ${activeIndex === 0 ? 'w-1/2' : 'w-full'}`}></div>
              </div>
              <span>2</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
